import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { RootState } from '../../models/RootState';
import {
  getAllMarketsByEvent,
  getFancyMarketsByEvent,
  addExchangeBet,
  getCurrencyTypeFromToken,
} from '../../store';
import './ExchFancyMarketsTable.scss';

import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
} from '@material-ui/core';
import { BsData, PlaceBetRequest } from '../../models/BsData';
import ExchOddBtn from '../ExchOddButton/ExchOddButton';
import { UserBet } from '../../models/UserBet';
import moment from 'moment';
import InfoImg from '../../assets/images/sportsbook/info.svg';
import { EventDTO } from '../../models/common/EventDTO';
import { FancyMarketDTO } from '../../models/common/FancyMarketDTO';
import API from '../../api';
import Modal from '../../components/Modal/Modal';
import MarketTermsCondi from '../../components/MarketTermsCondi/MarketTermsCondi';
import { IonButton, IonIcon } from '@ionic/react';
import FancyBookView from './FancyBookView/FancyBookView';
import { CURRENCY_TYPE_FACTOR } from '../../constants/CurrencyTypeFactor';
import { isFancyMarketSuspended } from '../../store/exchangeSports/exchangeSportsSelectors';
import { ThousandFormatter } from '../../util/stringUtil';

type StoreProps = {
  eventData: EventDTO;
  fmData: FancyMarketDTO[];
  openBets: UserBet[];
  commissionEnabled: boolean;
  addExchangeBet: (data: PlaceBetRequest) => void;
  loggedIn: boolean;
  getFormattedMinLimit: (num: number) => string;
  getFormattedMaxLimit: (num: number) => string;
  bets: PlaceBetRequest[];
  exposureMap: any;
  fancySuspended?: boolean;
  langData : any;
  fetchEvent: (
    sportId: string,
    competitionId: string,
    eventId: string,
    marketTime: string
  ) => void;
};

type Props = StoreProps & {
  loggedIn: boolean;
  getFormattedMinLimit: (num: number) => string;
  getFormattedMaxLimit: (num: number) => string;
};

type OddsInfoMsg = {
  launch: boolean;
  oddsType: string;
  eventTypeID: string;
};

const FMTable: React.FC<Props> = (props) => {
  const {
    eventData,
    fmData,
    bets,
    openBets,
    commissionEnabled,
    addExchangeBet,
    loggedIn,
    exposureMap,
    fancySuspended,
    fetchEvent,
    getFormattedMinLimit,
    getFormattedMaxLimit,
    langData,
  } = props;

  const [minStake, setMinStake] = useState<number>(100);
  const [maxStake, setMaxStake] = useState<number>(50000);

  const disabledStatus = ['suspended', 'suspended-manually', 'ball_running'];
  const [showBooksModal, setShowBooksModal] = useState<boolean>(false);
  const [fancyBookOutcomeId, setFancyBookOutcomeId] = useState<string>();
  const [fancyBookOutcomeName, setFancyBookOutcomeName] = useState<string>();
  const [selectedRow, setSelectedRow] = useState<string>('');
  const [infoDilalog, setInfoDialog] = useState<OddsInfoMsg>({
    launch: false,
    oddsType: null,
    eventTypeID: null,
  });
  const fancyGroups = [
    // { key: 'ball-by-ball', label: 'Ball by Ball' },
    // { key: 'over-by-over', label: 'Over by Over' },
    { key: 'fancy2', label: 'session-market' },
  ];
  // todo : remove all market limits usage and commented code if limits is working fine
  const [marketLimits, setMarketLimits] = useState<any>({});
  const [filteredFancyMarketsData, setFilteredFancyMarketsData] = useState<FancyMarketDTO[]>([]);
  const cFactor = CURRENCY_TYPE_FACTOR[getCurrencyTypeFromToken()];

  // const fetchBetLimits = async (marketId: string, localMCategory: string) => {
  //   try {
  //     const payload = {
  //       competitionId: eventData.competitionId,
  //       eventId: eventData.eventId,
  //       marketId: marketId,
  //       marketType: 'FANCY',
  //       outcomeDesc: 'fancy',
  //       sessionId: marketId,
  //       sportId: eventData.sportId,
  //       mcategory: localMCategory,
  //     };

  //     let response;
  //     if (sessionStorage.getItem('jwt_token')) {
  //       response = await API.post('/bs/fetch-market-limits', payload, {
  //         headers: {
  //           Authorization: sessionStorage.getItem('jwt_token'),
  //         },
  //       });
  //     } else {
  //       response = await API.post('/bs/fetch-market-limits', payload);
  //     }
  //     if (response.status === 200 && response.data.success) {

  //       let limits = marketLimits;

  //       limits[marketId ? marketId : eventData.marketId] = {
  //         minStake: response.data.limits.minStake,
  //         maxStake: response.data.limits.maxStake,
  //         maxOdd: response.data.limits.maxOdd,
  //       };

  //       setMarketLimits(marketLimits => {
  //         return {
  //           ...marketLimits,
  //           ...limits
  //         }
  //       });

  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  const getFancyMarketsByGroup = (category: string) => {
    return fmData
      .filter((fm) => fm.category === category)
      .sort((a, b) => {
        if (a?.sort - b?.sort != 0) {
          return a?.sort - b?.sort;
        }
        const aDesc = a.marketName;
        const bDesc = b.marketName;
        if (aDesc > bDesc) return 1;
        else if (aDesc < bDesc) return -1;
        return 0;
      });
  };

  return (
    <>
      <div className="fm-table-ctn">
        <div className="fm-table-content table-ctn">
          <TableContainer component={Paper}>
            <Table className="fm-table">
              <TableHead>
                <TableRow>
                  <TableCell colSpan={6}>
                    <div className="market-name-cell-head-ctn">
                      <span>
                      {langData?.['fancy']}
                        <IonIcon
                          onClick={() =>
                            setInfoDialog({
                              launch: true,
                              oddsType: 'Fancy',
                              eventTypeID: eventData.sportId,
                            })
                          }
                          className="info-img"
                          src={InfoImg}
                        />
                      </span>
                      {/* <span>
                      {langData?.['min']}: {minStake ? ThousandFormatter(
                        minStake
                          ? Math.min(...fmData.map(fm => fm?.marketLimits?.minStake || minStake)) / cFactor
                          : 100, "min"
                      ) : 0} {langData?.['max']}:{' '}
                        {maxStake ?
                          ThousandFormatter(
                            maxStake
                              ? Math.max(...fmData.map(fm => fm?.marketLimits?.maxStake || maxStake)) / cFactor
                              : 100, "max"
                          ) : 0}
                      </span> */}
                    </div>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
              {fmData && fmData.length > 0 ? (
                  <>
                    {fancyGroups.map((group) => (
                      <>
                      <FancyHeaderRow groupName={group.label} langData={langData} />
                      {getFancyMarketsByGroup(group.key).map(
                        (fMarket, index) => (
                          <FancyMarketRow
                            eventData={eventData}
                            fMarket={fMarket}
                            index={index}
                            // getOpenBetsRiskValue={getOpenBetsRiskValue}
                            // getRiskValue={getRiskValue}
                            // enableFancy={enableFancy}
                            disabledStatus={disabledStatus}
                            addExchangeBet={addExchangeBet}
                            setShowBooksModal={() => {
                              setFancyBookOutcomeId(fMarket.marketId);
                              setFancyBookOutcomeName(fMarket.marketName);
                              setShowBooksModal(true);
                            }}
                            outcomeOpenBets={openBets.filter(
                              (b) =>
                                b.marketType === 2 &&
                                b.outcomeId === fMarket.marketId
                            )}
                            exposureMap={exposureMap}
                            bets={bets}
                            selectedRow={selectedRow}
                            setSelectedRow={setSelectedRow}
                            minStake={
                              fMarket?.marketLimits?.minStake
                                ? fMarket?.marketLimits?.minStake
                                : marketLimits[fMarket?.marketId]
                                    ?.minStake
                            }
                            maxStake={
                              fMarket?.marketLimits?.maxStake
                                ? fMarket?.marketLimits?.maxStake
                                : marketLimits[fMarket?.marketId]
                                    ?.maxStake
                            }
                            oddLimit={
                              fMarket?.marketLimits?.maxOdd?.toString()
                                ? fMarket?.marketLimits?.maxOdd?.toString()
                                : marketLimits[fMarket?.marketId]?.maxOdd
                            }
                            fancySuspended={fancySuspended} langData={langData} 
                          />
                        )
                      )}
                    </>
                    ))}
                  </>
                ) : (
                  <TableRow>
                    <TableCell colSpan={3}>
                      <div className="fm-table-msg-text">
                      {langData?.['fancy_markets_not_found_txt']}
                      </div>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <Modal
            open={infoDilalog.launch}
            closeHandler={() =>
              setInfoDialog({
                launch: false,
                oddsType: null,
                eventTypeID: null,
              })
            }
            customClass="light-bg-title"
            title={langData?.['rules']}
            size="md"
          >
            <MarketTermsCondi
              oddsType={infoDilalog.oddsType}
              eventTypeID={infoDilalog.eventTypeID}
            />
          </Modal>

          <Modal
            open={showBooksModal}
            closeHandler={() => {
              setShowBooksModal(false);
              setFancyBookOutcomeId(null);
            }}
            customClass="fancy-book-dialog"
            title="Book List"
            size="sm"
          >
            <FancyBookView fancyBookOutcomeId={fancyBookOutcomeId}
            exposureMap={
              exposureMap &&
              exposureMap &&
              exposureMap[`${fancyBookOutcomeId}:${fancyBookOutcomeName}`]
                ? exposureMap[`${fancyBookOutcomeId}:${fancyBookOutcomeName}`]
                : {}
            } />
          </Modal>
        </div>
      </div>
    </>
  );
};

type FancyHeaderRowProps = {
  groupName: string;
  langData: any;
};

const FancyHeaderRow: React.FC<FancyHeaderRowProps> = (props) => {
  const { groupName, langData } = props;
  const tableFields = [
    {
      key: 'groupName',
      Label: groupName,
      className: 'market-name-cell-head',
      align: 'left',
    },
    {
      key: 'odds-no',
      Label: 'No',
      className: 'odds-cell-head odds-no-cell',
      align: 'center',
    },
    {
      key: 'odds-yes',
      Label: 'Yes',
      className: 'odds-cell-head odds-yes-cell',
      align: 'center',
    },
  ];

  return (
    <TableRow className="header-row">
      {tableFields.map((tF, index) => (
        <TableCell
          key={tF.key + index}
          align={tF.align === 'left' ? 'left' : 'center'}
          className={tF.className}
        >
          {tF.key === 'odds-no' || 'odds-yes' ? (
            <div className={tF.key.toLowerCase() + '-cell'}>{langData?.[tF.Label.toLowerCase()]}</div>
          ) : (
            langData?.[groupName.toLowerCase()]
          )}
        </TableCell>
      ))}
    </TableRow>
  );
};

type FancyMarketRowProps = {
  eventData: EventDTO;
  fMarket: FancyMarketDTO;
  index: number;
  // getOpenBetsRiskValue: (fMarket: FancyMarketDTO) => string;
  // getRiskValue: (fMarket: FancyMarketDTO) => string;
  disabledStatus: string[];
  addExchangeBet: (data: PlaceBetRequest) => void;
  setShowBooksModal: () => void;
  outcomeOpenBets: UserBet[];
  fancySuspended: boolean;
  maxStake: number;
  minStake: number;
  exposureMap: any;
  selectedRow: string;
  bets: PlaceBetRequest[];
  oddLimit: string;
  langData:any;
  setSelectedRow: (data) => void;
};

const FancyMarketRow: React.FC<FancyMarketRowProps> = (props) => {
  const {
    eventData,
    fMarket,
    index,
    // getOpenBetsRiskValue,
    // getRiskValue,
    disabledStatus,
    addExchangeBet,
    setShowBooksModal,
    outcomeOpenBets,
    fancySuspended,
    exposureMap,
    minStake,
    maxStake,
    oddLimit,
    langData,
    setSelectedRow
  } = props;
  
  const cFactor = CURRENCY_TYPE_FACTOR[getCurrencyTypeFromToken()];

  const isFancySuspended = (fMarketSuspended : boolean) => {
    return fancySuspended === true ? true : fMarketSuspended;
  }

  return (
    <TableRow key={'row-' + index}>
      <TableCell className="market-name-cell" key={'row-' + index + 'cell-1'}>
        <div className="market fancy-alin-col">
          {fMarket.marketName} {' '}
          {fMarket.commissionEnabled
            ? (
              <span className='blink-commission-fancy'>*</span>
            ) : null}
        </div>
      </TableCell>
      <TableCell className="odds-cell" key={'row-' + index + 'cell-2'}>
        <div className="odds-block">
          <ExchOddBtn
            mainValue={fMarket.layPrice}
            mainValueClass="runs"
            subValue={fMarket.laySize}
            subValueClass="odds"
            oddType="odds-no-cell"
            valueType="fancyMarketOdds"
            disable={
              disabledStatus.includes(fMarket.status.toLowerCase()) ||
               isFancySuspended(fMarket.suspend) === true ||
              moment(eventData.openDate).diff(moment(), 'minutes') > 60 * 24 * 2
            }
            onClick={() =>
              addExchangeBet({
                sportId: eventData.sportId,
                seriesId: eventData.competitionId,
                seriesName: eventData.competitionName,
                eventId: eventData.eventId,
                eventName: eventData.eventName,
                eventDate: eventData.openDate,
                marketId: fMarket.marketId,
                marketName: fMarket.marketName,
                marketType: 'FANCY',
                outcomeId: fMarket.marketId,
                outcomeDesc: '@ ' + fMarket.layPrice,
                betType: 'LAY',
                amount: 0,
                oddValue: fMarket.laySize,
                sessionPrice: fMarket.layPrice,
                oddLimt: oddLimit,
                minStake: minStake,
                maxStake: maxStake,
                mcategory: fMarket.category,
              })
            }
          />
        </div>
      </TableCell>
      <TableCell className="odds-cell" key={'row-' + index + 'cell-3'}>
        <div className="odds-block">
        <ExchOddBtn
            mainValue={fMarket.backPrice}
            mainValueClass="runs"
            subValue={fMarket.backSize}
            subValueClass="odds"
            oddType="odds-yes-cell"
            valueType="fancyMarketOdds"
            disable={
              disabledStatus.includes(fMarket.status.toLowerCase()) ||
                isFancySuspended(fMarket.suspend) === true ||
              moment(eventData.openDate).diff(moment(), 'minutes') > 60 * 24 * 2
            }
            onClick={() => {
              if (!disabledStatus.includes(fMarket.status.toLowerCase()) || 
                  isFancySuspended(fMarket.suspend) === true) {
                setSelectedRow(fMarket.marketName + 'FM');
                addExchangeBet({
                  sportId: eventData.sportId,
                  seriesId: eventData.competitionId,
                  seriesName: eventData.competitionName,
                  eventId: eventData.eventId,
                  eventName: eventData.eventName,
                  eventDate: eventData.openDate,
                  marketId: fMarket.marketId,
                  marketName: fMarket.marketName,
                  marketType: 'FANCY',
                  outcomeId: fMarket.marketId,
                  outcomeDesc: '@ ' + fMarket.backPrice,
                  betType: 'BACK',
                  amount: 0,
                  oddValue: fMarket.backSize,
                  sessionPrice: fMarket.backPrice,
                  oddLimt: oddLimit,
                  minStake: minStake,
                  maxStake: maxStake,
                  mcategory: fMarket.category,
                });
              }
            }}
          />
        </div>
      </TableCell>
      {disabledStatus.includes(fMarket.status.toLowerCase()) || 
        isFancySuspended(fMarket.suspend) === true ? (
        <div className="disabled-odds-cell" key={'row-' + index + 'cell-5'}>
          {fMarket.status.toLowerCase().includes('suspended') || isFancySuspended(fMarket.suspend) === true
            ? 'SUSPENDED'
            : fMarket.status.replace('_', ' ')}
        </div>
      ) : <div></div>}
      <TableCell>
      <IonButton
          className="fancy-book-btn"
          onClick={() => {
            if (exposureMap &&
              exposureMap[
              `${fMarket.marketId}:${fMarket.marketName}`
              ]) setShowBooksModal();
          }}
          disabled={!(exposureMap &&
            exposureMap[
            `${fMarket.marketId}:${fMarket.marketName}`
            ])}
        >
           {langData?.['book']}
        </IonButton>
        <div className="row mob-view mob-bet-limits">
          <div>{langData?.['min']}: {minStake ? ThousandFormatter(
            minStake
              ? minStake / cFactor
              : 100, "min"
          ) : 0}</div> <div> {langData?.['max']}: {maxStake ?
            ThousandFormatter(
              maxStake
                ? maxStake / cFactor
                : 100, "max"
            ) : 0}</div>
        </div>
      </TableCell>
      <TableCell className="limits-cell web-view">
        <div className="limits-data">
          <div className="row web-view">{langData?.['min']}: {minStake ? ThousandFormatter(
            minStake
              ? minStake / cFactor
              : 100, "min"
          ) : 0} {langData?.['max']}: {
              maxStake ?
                maxStake % 1000 === 0 ?
                  ThousandFormatter(
                    maxStake
                      ? maxStake / cFactor
                      : 100, "max"
                  ) : maxStake
                    ? Math.round(maxStake / cFactor)
                    : 100
                : 0}</div>
          <div className="row mob-view">
            <div>{langData?.['min']}: {minStake ? ThousandFormatter(
              minStake
                ? minStake / cFactor
                : 100, "min"
            ) : 0}</div> <div> {langData?.['max']}: {
              maxStake ?
                maxStake % 1000 === 0 ?
                  ThousandFormatter(
                    maxStake
                      ? maxStake / cFactor
                      : 100, "max"
                  ) : maxStake
                    ? maxStake / cFactor
                    : 100
                : 0}</div>
          </div>
          {/* <div className="row"></div> */}
        </div>
      </TableCell>
    </TableRow>
  );
};

const mapStateToProps = (state: RootState) => {
  const eventType = state.exchangeSports.selectedEventType;
  const competition = state.exchangeSports.selectedCompetition;
  const event = state.exchangeSports.selectedEvent;
  return {
    eventData: getAllMarketsByEvent(
      state.exchangeSports.events,
      eventType.id,
      competition.id,
      event.id
    ),
    fmData: getFancyMarketsByEvent(
      state.exchangeSports.secondaryMarketsMap,
      event.id
    ),
    bets: state.exchBetslip.bets,
    openBets: state.exchBetslip.openBets,
    commissionEnabled: state.common.commissionEnabled,
    langData:state.common.langData,
    fancySuspended: isFancyMarketSuspended (
      state.exchangeSports.secondaryMarketsMap,
      event.id
    ),
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    addExchangeBet: (data: PlaceBetRequest) => dispatch(addExchangeBet(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FMTable);
